/**
 * Paths served by other apps behind this dashboard's Vercel rewrites (see
 * vercel.json). The dashboard's router does not own them, so a post-login
 * redirect to one must be a full page load: navigate() would render the
 * dashboard's own 404 instead of reaching the rewrite.
 */
const EXTERNAL_APP_PREFIXES = ['/insights'] as const;

export const isExternalAppPath = (path: string): boolean =>
  EXTERNAL_APP_PREFIXES.some(
    prefix =>
      path === prefix ||
      path.startsWith(`${prefix}/`) ||
      path.startsWith(`${prefix}?`) ||
      path.startsWith(`${prefix}#`),
  );

type Navigate = (to: string, options: { replace: boolean }) => void;

/** Send the user to an already-sanitized post-login target. */
export const goToPostLoginTarget = (
  target: string,
  navigate: Navigate,
  assign: (url: string) => void = url => window.location.assign(url),
): void => {
  if (isExternalAppPath(target)) {
    assign(target);
    return;
  }
  navigate(target, { replace: true });
};
